import type { ReactNode } from "react";

export function highlightMatch(
  text: string | null | undefined,
  term: string
): ReactNode {
  const safeText = text ?? "";
  if (!term) return safeText;
  const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escaped})`, "gi");
  const parts = safeText.split(regex);
  if (parts.length === 1) return safeText;
  return parts.map((part, i) =>
    regex.test(part) ? <strong key={i}>{part}</strong> : part
  );
}
